import { call, put, takeLatest } from "redux-saga/effects";

import { apiCreateArticles } from "helpers/api/articles";
import {
  CREATE_ARTICLES,
  actCreateArticlesFailed,
  actCreateArticlesSuccess,
} from "store/actions/articles";
import { showToastError, showToastSuccess } from "utils";

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doCreate(action) {
  try {
    const response = yield call(apiCreateArticles, action?.payload);

    if (response?.data) {
      // Call callback action if provided
      yield put(actCreateArticlesSuccess(response.data));

      if (action.onSuccess) {
        yield action.onSuccess();
      }
      showToastSuccess("messages.MSG-USP091");
    } else {
      throw new Error(
        response?.error?.reason
          ? `messages.${response?.error?.reason}`
          : response?.error?.message
      );
    }
  } catch (error) {
    yield put(actCreateArticlesFailed());
    // Call callback action if provided
    showToastError(error?.message);
    if (action.onError) {
      yield action.onError(error);
    }
  }
}

export default function* watchCreate() {
  yield takeLatest(CREATE_ARTICLES, doCreate);
}
